<p>
  Sets the target's temp HP.
  <avr-autodoc-link anchor="temphp"></avr-autodoc-link>
</p>

<!-- amount -->
<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center" class="auto-row">
  <mat-form-field fxFlex="grow">
    <input matInput placeholder="Amount" (change)="changed.emit()" [(ngModel)]="effect.amount" required>
    <span matSuffix matTooltip="AnnotatedString - variables and functions allowed in braces">{{"{ }"}}</span>
  </mat-form-field>
</div>

<!-- spell options -->
<div *ngIf="spell != null">
  <p class="auto-label">Spell Options</p>
  <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="8px" fxLayoutAlign="left center">
    <avr-higher-level [parent]="effect" [spell]="spell" (changed)="changed.emit()"></avr-higher-level>
    <mat-checkbox [(ngModel)]="effect.cantripScale" (change)="changed.emit()">
      Scales like Cantrip
    </mat-checkbox>
  </div>
</div>

